/* ALL THINGS BIG - privacy choices (Oct 31 legal pass, single-banner version).
   ONE cookie banner: Shopify's own (Admin > Settings > Customer privacy). It is opt-in everywhere, honors Global Privacy
   Control for data-sale opt-out, and blocks analytics + marketing cookies until the visitor chooses. This theme no longer
   draws a second banner. This file only READS Shopify's consent state (Shopify.customerPrivacy.currentVisitorConsent) and
   never calls setTrackingConsent, so Shopify stays the single source of truth.
   1) YouTube thumbnails (images fetched from Google's servers) load after the visitor accepts cookies in Shopify's banner,
      or presses "Show thumbnails" (remembered on this device only), and are requested with no referrer. Declining keeps
      them off. Video players open only when a video is pressed and always use youtube-nocookie.com.
   2) Tells the CSS how tall Shopify's banner is (--bbb-ch, class bbb-consent-on) so the mobile quick-buy bar and the
      "Added to your bag" toast sit above it instead of under it.
   3) The footer "Cookie choices" button re-opens Shopify's preferences dialog. */
(function () {
  if (window.__bbbConsent) return;
  window.__bbbConsent = true;
  var YT = 'bbbYtThumbs';
  function get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function put(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }

  /* ---------- read Shopify's consent state ---------- */
  var tries = 0;
  function accepted() {
    try {
      var cp = window.Shopify && Shopify.customerPrivacy;
      var c = cp && cp.currentVisitorConsent && cp.currentVisitorConsent();
      return !!c && c.marketing === 'yes';
    } catch (e) { return false; }
  }
  function boot() {
    if (!window.Shopify || !Shopify.loadFeatures) { if (tries++ < 150) setTimeout(boot, 100); return; }
    Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) { if (!err) sync(); });
  }

  /* ---------- YouTube thumbnails ---------- */
  var loaded = false;
  function loadThumbs() {
    loaded = true;
    var imgs = document.querySelectorAll('img[data-bbb-src]');
    for (var i = 0; i < imgs.length; i++) {
      var im = imgs[i]; var u = im.getAttribute('data-bbb-src');
      im.removeAttribute('data-bbb-src'); im.referrerPolicy = 'no-referrer'; im.src = u;
    }
    var notes = document.querySelectorAll('[data-bbb-yt-note]');
    for (var j = 0; j < notes.length; j++) notes[j].hidden = true;
    document.documentElement.setAttribute('data-bbb-yt', 'on');
  }
  function sync() {
    if (loaded) return;
    if (get(YT) === '1' || accepted()) loadThumbs();
    else {
      var notes = document.querySelectorAll('[data-bbb-yt-note]');
      for (var j = 0; j < notes.length; j++) notes[j].hidden = false;
    }
  }

  /* ---------- keep the quick-buy bar and toast above Shopify's banner ---------- */
  var ro = null, mo = null, bn = null;
  function offset() {
    var r = document.documentElement, b = document.getElementById('shopify-pc__banner');
    var on = !!b && b.offsetHeight > 0 && getComputedStyle(b).display !== 'none';
    if (!on) { r.classList.remove('bbb-consent-on'); r.style.removeProperty('--bbb-ch'); return; }
    var rect = b.getBoundingClientRect();
    r.style.setProperty('--bbb-ch', Math.max(0, Math.round(window.innerHeight - rect.top)) + 'px');
    r.classList.add('bbb-consent-on');
  }
  function watch() {
    var b = document.getElementById('shopify-pc__banner');
    if (b && b !== bn) {
      bn = b;
      if ('ResizeObserver' in window) { if (ro) ro.disconnect(); ro = new ResizeObserver(offset); ro.observe(b); }
      if (mo) mo.disconnect();
      mo = new MutationObserver(offset); mo.observe(b, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
    }
    offset();
  }
  function startWatch() {
    new MutationObserver(watch).observe(document.body, { childList: true });
    window.addEventListener('resize', offset, { passive: true });
    watch();
  }

  function ready() {
    sync();
    boot();
    startWatch();
    document.addEventListener('visitorConsentCollected', function () { sync(); setTimeout(offset, 50); });
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-bbb-yt-load],[data-bbb-consent-open]');
      if (!t) return;
      if (t.hasAttribute('data-bbb-yt-load')) { put(YT, '1'); loadThumbs(); }
      else if (t.hasAttribute('data-bbb-consent-open')) {
        e.preventDefault();
        var pb = window.privacyBanner;
        if (pb && pb.showPreferences) pb.showPreferences();
        else if (pb && pb.showBanner) pb.showBanner();
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready); else ready();
})();
